import type { ReactNode } from 'react';
import geoAgentAvatar from '../../assets/geo-agent.png';

// Faint lightning texture that fades in from the right of the banner.
const GEO_LIGHTNING =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3E%3Cpath d='M17 4l-6 10h4l-2 8 7-11h-4z' fill='%23C4B5FD'/%3E%3C/svg%3E\")";

/**
 * The GEO Agent banner (Figma 2190:39097) — shared by Script Review and Content
 * Review so both surfaces look identical: gradient card, avatar, "GEO Agent" +
 * subtitle, and an optional action (a pill button) on the right.
 */
export function GeoAgentBanner({
  subtitle,
  action,
}: {
  subtitle: string;
  action?: ReactNode;
}) {
  return (
    <div
      className="relative overflow-hidden rounded-[14px] border border-[#DBBEFE] px-5 py-4"
      style={{ background: 'linear-gradient(90deg,#FDFCFE 0%,#F5F1FC 60%,#EAE5F8 100%)' }}
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-y-0 right-0 left-1/3"
        style={{
          backgroundImage: GEO_LIGHTNING,
          backgroundSize: '26px 26px',
          opacity: 0.6,
          WebkitMaskImage: 'linear-gradient(90deg, transparent, #000 60%)',
          maskImage: 'linear-gradient(90deg, transparent, #000 60%)',
        }}
      />
      <div className="relative flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <img src={geoAgentAvatar} alt="" aria-hidden className="size-[52px] shrink-0 rounded-full" />
          <div className="min-w-0">
            <div className="text-body-md-semibold text-foreground">GEO Agent</div>
            <div className="text-caption-regular text-[#737373]">{subtitle}</div>
          </div>
        </div>
        {action}
      </div>
    </div>
  );
}
